/**
 * Syncs wholesale cart line prices with the Wholesale Pricing Now app discount ratio.
 */
(function () {
  if (window.__tbWholesaleCartFixInitialized) return;
  window.__tbWholesaleCartFixInitialized = true;

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function parseMoneyToCents(text) {
    const numeric = (text || '').replace(/[^0-9.]/g, '');
    const value = parseFloat(numeric);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }

  function getQuantity(cartItem) {
    const quantityInput = cartItem.querySelector('.cart-item__quantity-input');
    return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
  }

  function getWNPricePair(root) {
    if (!root) return null;

    const original = root.querySelector('.wn-original-subtotal');
    const discounted = root.querySelector('.wn-discounted-subtotal');
    if (!original || !discounted) return null;

    const originalCents = parseMoneyToCents(original.textContent);
    const discountedCents = parseMoneyToCents(discounted.textContent);
    if (originalCents <= 0 || discountedCents < 0 || discountedCents >= originalCents) {
      return null;
    }

    return { originalCents, discountedCents };
  }

  function getCartDiscountMultiplier() {
    const sources = [
      document.querySelector('.cart-drawer__footer [data-merge="footer"] .subtotal'),
      document.querySelector('.checkout-subtotal-container .subtotal'),
      document.querySelector('cart-form .subtotal')
    ];

    for (const source of sources) {
      const pair = getWNPricePair(source);
      if (pair) {
        return pair.discountedCents / pair.originalCents;
      }
    }

    const cartItem = document.querySelector('.cart-item .cart-item__wn-target');
    const pair = getWNPricePair(cartItem);
    if (pair) {
      return pair.discountedCents / pair.originalCents;
    }

    return null;
  }

  function getItemDiscountMultiplier(cartItem) {
    const fromWN = getCartDiscountMultiplier();
    if (fromWN !== null) {
      return fromWN;
    }

    const multiplier = parseInt(cartItem.dataset.discountMultiplier, 10);
    if (multiplier > 0 && multiplier < 100) {
      return multiplier / 100;
    }

    const wholesaleUnit = parseInt(cartItem.dataset.wholesaleUnitPrice, 10);
    const retailUnit = parseInt(cartItem.dataset.retailUnitPrice, 10);
    if (wholesaleUnit && retailUnit && wholesaleUnit < retailUnit) {
      return wholesaleUnit / retailUnit;
    }

    return null;
  }

  function cleanWholesaleAppMarkup(cartItem) {
    cartItem.querySelectorAll(
      '.cart-item__price-display .wn-original-subtotal, .cart-item__price-display .wn-discounted-subtotal'
    ).forEach((el) => el.remove());
  }

  function restoreCartItemPrices(cartItem) {
    const retailUnit = parseInt(cartItem.dataset.retailUnitPrice, 10);
    if (!retailUnit) return;

    const multiplier = getItemDiscountMultiplier(cartItem);
    if (multiplier === null) return;

    const quantity = getQuantity(cartItem);
    const wholesaleUnit = Math.round(retailUnit * multiplier);
    const wholesaleLine = wholesaleUnit * quantity;
    const retailLine = retailUnit * quantity;
    const useLineTotal = cartItem.dataset.priceMode === 'line-total';

    cartItem.dataset.discountMultiplier = String(Math.round(multiplier * 100));
    cartItem.dataset.wholesaleUnitPrice = String(wholesaleUnit);

    cleanWholesaleAppMarkup(cartItem);

    const unitDisplay = cartItem.querySelector('.cart-item__display-price');
    const totalDisplay = cartItem.querySelector('.cart-item__display-total');
    const unitStruck = cartItem.querySelector('.cart-item__price .struck-out-price .theme-money');
    const totalStruck = cartItem.querySelector('.cart-item__total .struck-out-price');

    if (unitDisplay) {
      unitDisplay.textContent = formatMoney(useLineTotal ? wholesaleLine : wholesaleUnit);
    }

    if (unitStruck) {
      unitStruck.textContent = formatMoney(useLineTotal ? retailLine : retailUnit);
    }

    if (totalDisplay) {
      totalDisplay.textContent = formatMoney(wholesaleLine);
    }

    if (totalStruck) {
      totalStruck.textContent = formatMoney(retailLine);
    }
  }

  function fixAll() {
    const multiplier = getCartDiscountMultiplier();
    if (multiplier === null) return;

    document.querySelectorAll('.cart-item[data-retail-unit-price]').forEach(restoreCartItemPrices);
  }

  function scheduleFix() {
    window.requestAnimationFrame(fixAll);
  }

  document.addEventListener('on:cart:after-merge', scheduleFix);
  document.addEventListener('change', (event) => {
    if (event.target.matches('.cart-item__quantity-input')) {
      scheduleFix();
    }
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const nodes = mutation.type === 'childList' ? [...mutation.addedNodes] : [mutation.target];
      for (const node of nodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.classList?.contains('wn-original-subtotal')
          || node.classList?.contains('wn-discounted-subtotal')
          || node.querySelector?.('.wn-original-subtotal, .wn-discounted-subtotal')
        ) {
          scheduleFix();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  scheduleFix();
})();
